// removed by extract-text-webpack-plugin
module.exports = {"item-container":"item-container___2y6Du","render-text-container":"render-text-container___aAiZ6","item-input-container":"item-input-container___1w-1h","item-del-icon":"item-del-icon___3oMwi"};


//////////////////
// WEBPACK FOOTER
// ./src/components_business/SkusEdit/SkusItem/SkusChildItem/Index.less
// module id = r7TO
// module chunks = 10 11